var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.11564V10.1156M9.25 3.61563H5.8C4.11984 3.61563 3.27976 3.61563 2.63803 3.94261C2.07354 4.23024 1.6146 4.68918 1.32698 5.25366C0.999998 5.8954 0.999999 6.73548 1 8.41564L1 9.61563C1 10.5475 1 11.0135 1.15224 11.381C1.35523 11.8711 1.74458 12.2604 2.23463 12.4634C2.60218 12.6156 3.06812 12.6156 4 12.6156V16.8656C4 17.0978 4 17.2139 4.00963 17.3117C4.10316 18.2612 4.85441 19.0125 5.80397 19.106C5.90175 19.1156 6.01783 19.1156 6.25 19.1156C6.48217 19.1156 6.59826 19.1156 6.69604 19.106C7.64559 19.0125 8.39685 18.2612 8.49037 17.3117C8.5 17.2139 8.5 17.0978 8.5 16.8656V12.6156H9.25C11.0164 12.6156 13.1772 13.5625 14.8443 14.4713C15.8168 15.0014 16.3031 15.2665 16.6216 15.2275C16.9169 15.1913 17.1402 15.0587 17.3133 14.8167C17.5 14.5558 17.5 14.0336 17.5 12.9893V3.24192C17.5 2.19763 17.5 1.67548 17.3133 1.41452C17.1402 1.17254 16.9169 1.03993 16.6216 1.00376C16.3031 0.964756 15.8168 1.22983 14.8443 1.75999C13.1772 2.66875 11.0164 3.61563 9.25 3.61563Z",
    stroke: "#38cb89",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.e6d81c2317bcfee8c0401bdd8c1fecc0.svg";
export { ForwardRef as ReactComponent };